<form [formGroup]="form" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <!--<button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>-->
            <!--<button [disabled]="!habilitarNuevoProducto" type="button" class="btn btn-outline-success" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo Producto</button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" class="btn btn-outline-success" type="button" (click)="guardarSolicitud()"><i class="fa fa-save"></i> Guardar Solicitud</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>-->
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Resumen {{refAtestFito}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudAtestFito | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="row">
                    <!--GRID PRODUCTOS-->
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">
                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Resumen</strong>
                            </div>
                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="resumenAtestFitoCollection"
                                         [columns]="colsResumen" sortField="FechaEnvio" sortOrder="1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(resumenAtestFitoCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>
                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='FechaEnvio' && col.field!=='PesoSolicitudEx' && col.field!=='VolumenSolicitudEx')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="(col.field==='PesoSolicitudEx' || col.field==='VolumenSolicitudEx')">
                                                    {{rowData[col.field] | number:'1.3-3':'es'}}
                                                </span>
                                                <span *ngIf="col.field==='FechaEnvio'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                                <div class="row" *ngIf="numeroResumen !== 0">
                                    <div class="col-md-12">
                                        <div class="card-body-detalle">
                                            <div class="row">
                                                <div class="form-group col-md-2 offset-md-1">
                                                    <label class="col-form-label" for="">Tipo Medida</label>
                                                    <input formControlName="TipoMedida" readonly name="TipoMedida" title="" class="form-control" id="" type="text" value="" maxlength="50">
                                                </div>
                                                <div class="form-group col-md-2 offset-md-1">
                                                    <label class="col-form-label" for="">Total Certificado</label>
                                                    <input formControlName="TotalCertificado" readonly name="TotalCertificado" title="" class="form-control" id="" type="text" value="" maxlength="50">
                                                </div>
                                                <div class="form-group col-md-2 offset-md-1">
                                                    <label class="col-form-label" for="">Total Exportado</label>
                                                    <input formControlName="TotalExportado" readonly name="TotalExportado" title="" class="form-control" id="" type="text" value="" maxlength="50">
                                                </div>
                                                <div class="form-group col-md-2 offset-md-1">
                                                    <label class="col-form-label" for="">Resto Exportación</label>
                                                    <input formControlName="RestoExportacion" readonly name="RestoExportacion" title="" class="form-control" id="" type="text" value="" maxlength="50">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="numeroResumen === 0" class="empty-grid">
                                    Esta atestación no ha sido utilizada aún en ninguna Solicitud de Exportación
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
